__turbopack_context__.v({
  "backdrop": "Overlay-module__5ctvKq__backdrop",
  "body": "Overlay-module__5ctvKq__body",
  "bodyContainer": "Overlay-module__5ctvKq__bodyContainer",
  "botanical": "Overlay-module__5ctvKq__botanical",
  "closeBar": "Overlay-module__5ctvKq__closeBar",
  "closeControl": "Overlay-module__5ctvKq__closeControl",
  "closeIcon": "Overlay-module__5ctvKq__closeIcon",
  "closeLabel": "Overlay-module__5ctvKq__closeLabel",
  "contentColumn": "Overlay-module__5ctvKq__contentColumn",
  "contentInner": "Overlay-module__5ctvKq__contentInner",
  "mediaColumn": "Overlay-module__5ctvKq__mediaColumn",
  "mediaImage": "Overlay-module__5ctvKq__mediaImage",
  "modalNav": "Overlay-module__5ctvKq__modalNav",
  "navButton": "Overlay-module__5ctvKq__navButton",
  "navButtonIconEnd": "Overlay-module__5ctvKq__navButtonIconEnd",
  "navButtonIconStart": "Overlay-module__5ctvKq__navButtonIconStart",
  "navButtonTitle": "Overlay-module__5ctvKq__navButtonTitle",
  "navInner": "Overlay-module__5ctvKq__navInner",
  "overlay": "Overlay-module__5ctvKq__overlay",
  "panelBody": "Overlay-module__5ctvKq__panelBody",
  "panelBodyMedia": "Overlay-module__5ctvKq__panelBodyMedia",
  "panelBodySingle": "Overlay-module__5ctvKq__panelBodySingle",
  "panelInner": "Overlay-module__5ctvKq__panelInner",
  "sheet": "Overlay-module__5ctvKq__sheet",
  "slidePane": "Overlay-module__5ctvKq__slidePane",
  "threatsColumn": "Overlay-module__5ctvKq__threatsColumn",
  "threatsHeading": "Overlay-module__5ctvKq__threatsHeading",
  "title": "Overlay-module__5ctvKq__title",
});
